import { Outlet } from "react-router-dom";
import { Provider } from "react-redux";

import Header from "../../layouts/Header";

import store from "../../store/store";
import Footer from "../../layouts/Footer";

const MainRoot = () => {
  return (
    <>
      <Provider store={store}>
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
      </Provider>
    </>
  );
};

export default MainRoot;
